/**
 * The create flow's fixed shape (CT-5525).
 *
 * Fields are fixed per type on purpose: a tenant-driven form is a Data Studio
 * feature that does not exist yet. The types, though, are limited to those a
 * user can type in — Employees are AIMS OS members, so they are not offered.
 */

export const CREATABLE_TYPES = Object.freeze(['customers', 'companies']);

export const CREATE_STEP_IDS = Object.freeze(['identity', 'details', 'review']);

/** The field whose value decides "this record already exists", per type. */
export const IDENTITY_KEY_FIELD = Object.freeze({
  customers: 'email',
  companies: 'domain',
});

export const isCreatableType = (entityType) => CREATABLE_TYPES.includes(entityType);
